
import { useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';

import { text } from '../text';
import { hooks } from '../hooks';
import { utils } from '../utils';
import { theme } from '../constants';
import { components } from '../components';
import { svg } from '../assets/svg';
import useApi from '../customHook/useApi';
import { login } from '../environment';



export interface LoginResponse {
    success: boolean;
    statusCode: number;
    otp: string;
    phoneNumber: string;
    message: string;
}


export const Onboarding3: React.FC = () => {

    const { pathname } = useLocation();
    const navigate = hooks.useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedCode, setSelectedCode] = useState<string>('+91');
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [error, setError] = useState<string>("")


    const codes = ['+1', '+44', '+91', '+81', '+33', '+49', '+86', '+61', '+7', '+39', '+55', '+34', '+82', '+27', '+31', '+46', '+351', '+62'];

    const handleSelect = (code: string) => {
        setSelectedCode(code);
        setIsOpen(false);
    };
    const buttons = [
        {
            title: 'Continue',
            path: '/onbording4',
        }
    ];


    // const handleMobileConfirm = () => {
    //     console.log("handleMobileConfirm");
    //     console.log(phoneNumber);

    //     const trimmed = phoneNumber.trim();
    //     const digitsOnly = trimmed.replace(/\D/g, '');


    //     if (!trimmed) {
    //         setError("Mobile number is required.");
    //         return;
    //     }
    //     if (phoneNumber.length < 10) {
    //         setError("Phone number must be at least 10 digits long.")
    //         return
    //     }
    //     setError("");
    //     navigate("/onbording4")

    // }



    const {
        data: loginResponse,
        loading: loginLoading,
        callApi,
    } = useApi<LoginResponse>(login, {
        method: "POST",
        autoCall: false,
        dependencies: [],
    });



    const handleMobileConfirm = () => {
        const trimmed = phoneNumber.trim();
        const digitsOnly = trimmed.replace(/\D/g, '');

        if (!digitsOnly) {
            setError("Mobile number is required.");
            return;
        }

        if (digitsOnly.length !== 10) {
            setError("Phone number must be 10 digits.");
            return;
        }

        setError("");

        // ✅ Corrected: send plain object
        callApi({
            phoneNumber: digitsOnly,
        });
    };

    useEffect(() => {
        localStorage.clear()
        sessionStorage.clear()
    }, [])

    useEffect(() => {
        if (loginResponse?.success) {
            console.log("OTP received:", loginResponse.otp);
            navigate("/onbording4", {
                state: {
                    otp: loginResponse.otp,
                    phoneNumber: loginResponse.phoneNumber,
                },
            });
        } else if (loginResponse && !loginResponse.success) {
            setError(loginResponse.message || "Login failed");
        }
    }, [loginResponse]);



    // Component Starts

    const renderTitle = (): JSX.Element => {
        return (
            <div className='container'>
                <p className='heading'> Enter Your Mobile Number</p>
            </div>
        );
    };
    const renderDescription2 = (): JSX.Element => {
        return (
            <div className='container' style={{ padding: "0", textAlign: "center" }}>
                <p className='termConditions' >
                    {/* By submitting you agree to our */}
                    I agree <span style={{ color: '#7065F0' }}> Terms & Conditions</span>
                </p>
                <p className='termConditions' >
                    For any issue/query, please email demo@nexfin.com

                </p>
            </div>
        );
    };

    const renderDescription = (): JSX.Element => {
        return (
            <div className='container'>
                <text.T16
                    style={{
                        lineHeight: 1,
                        textAlign: 'center',
                        whiteSpace: 'pre-line',


                    }}>
                    We will send you a verification code
                </text.T16>
            </div>
        );
    };

    const renderDescription1 = (): JSX.Element => {
        return (
            <div className="container">
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        marginTop: 10,
                        border: error ? '1px solid red' : '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '10px 12px',
                        backgroundColor: '#fff',
                    }}
                >
                    {/* Icon container */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <svg.CallSvg />
                    </div>

                    {/* Input field */}
                    <input
                        type="tel"
                        placeholder="Enter phone number"
                        value={phoneNumber}
                        onChange={e => {
                            setPhoneNumber(e.target.value.replace(/\D/, ''))
                            if (error) setError("")
                        }}
                        pattern="\d{10}"
                        maxLength={10}
                        style={{
                            fontSize: '16px',
                            border: 'none',
                            outline: 'none',
                            flex: 1,
                            padding: 0, // ensure no internal left padding
                        }}
                    />
                </div>
                {error && <div style={{ marginTop: "10px", fontSize: "15px", color: "red" }}>{error}</div>}

            </div>
        );
    };



    const renderButtons = (): JSX.Element => (
        <div
            style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                padding: '36px 16px 36px 16px',
                background: ' #ffffffa1',
                backdropFilter: 'blur(4px)',
                boxSizing: 'border-box',
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
            }}
        >
            <div
                className='button-container'
                style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
            >
                {renderTitle()}
                {renderDescription()}
                {renderDescription1()}


                {buttons.map((btn, index) => (
                    <div
                        key={index}
                        id="onbording3"
                        className={index === 0 ? 'active-button' : 'inactive-button'}
                        onClick={handleMobileConfirm}
                    // onClick={() => navigate(btn.path)}
                    >
                        <span>{btn.title}</span>
                    </div>
                    // <components.Button
                    //     key={index}
                    //     style={{
                    //         backgroundColor: index === 0 ? '#7065F0' : '#fff',
                    //         color: index === 0 ? '#fff' : '#7065F0',
                    //         border: '1px solid #7065F0',
                    //     }}
                    //     title={btn.title}
                    //     onClick={() => navigate(btn.path)}
                    // />
                ))}

                {renderDescription2()}

            </div>
        </div>
    );

    return (

        <div style={{ position: 'relative', height: '100dvh', overflow: 'hidden' }}>
            <div style={{ width: '100%', height: '100%', overflow: 'hidden', position: 'relative' }}>
                <img
                    src={require('../assets/nestfin/mainb1.jpg')}
                    alt='Onboarding Visual'
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                {renderButtons()}
            </div>
        </div>

    );
};


// 07-06-2025 code after check

// import { useLocation } from 'react-router-dom';
// import React, { useState } from 'react';
// import useEmblaCarousel from 'embla-carousel-react';

// import { text } from '../text';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { theme } from '../constants';
// import { components } from '../components';
// import { svg } from '../assets/svg';

// export const Onboarding3: React.FC = () => {

//     const { pathname } = useLocation();
//     const navigate = hooks.useNavigate();
//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedCode, setSelectedCode] = useState<string>('+91');
//     const [phoneNumber, setPhoneNumber] = useState<string>('');


//     const codes = ['+1', '+44', '+91', '+81', '+33', '+49', '+86', '+61', '+7', '+39', '+55', '+34', '+82', '+27', '+31', '+46', '+351', '+62'];

//     const handleSelect = (code: string) => {
//         setSelectedCode(code);
//         setIsOpen(false);
//     };
//     const buttons = [
//         {
//             title: 'Continue',
//             path: '/onbording4',
//         }
//     ];
//     const renderTitle = (): JSX.Element => {
//         return (
//             <div className='container'>
//                 <p className='heading'> Enter Your Mobile Number</p>
//                 {/* <text.H3
//                     style={{
//                         textTransform: 'capitalize',
//                         color: "#000",
//                         textAlign: "center",
//                         lineHeight: 1,

//                     }}
//                 >
//                     Enter Your Mobile Number
//                 </text.H3> */}
//             </div>
//         );
//     };
//     const renderDescription2 = (): JSX.Element => {
//         return (
//             <div className='container' style={{ padding: "0" }}>
//                 <p className='termConditions' >
//                     By submitting you agree to our
//                     {/* <span style={{ color: '#7065F0' }}> Terms & Conditions</span>  & <span style={{ color: '#7065F0' }}> Privacy Policy</span> */}
//                     <span style={{ color: '#7065F0' }}> Terms & Conditions</span>
//                 </p>
//                 <p className='termConditions' >
//                     For any issue/query please email demo@nexfin.com

//                 </p>
//             </div>
//         );
//     };

//     const renderDescription = (): JSX.Element => {
//         return (
//             <div className='container'>
//                 <text.T16
//                     style={{
//                         lineHeight: 1,
//                         textAlign: 'center',
//                         whiteSpace: 'pre-line',


//                     }}>
//                     We will send you a verification code
//                 </text.T16>
//             </div>
//         );
//     };
//     const renderDescription1 = (): JSX.Element => {
//         return (
//             <div className="container">
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: 10 }}>
//                     {/* Custom Dropdown */}
//                     <div style={{ position: 'relative' }}>
//                         <div
//                             onClick={() => setIsOpen(!isOpen)}
//                             style={{
//                                 padding: '12px',
//                                 borderRadius: '4px',
//                                 border: '1px solid #ccc',
//                                 cursor: 'pointer',
//                                 minWidth: '60px',
//                                 textAlign: 'center',
//                                 backgroundColor: "white"
//                             }}
//                         >
//                             {selectedCode}
//                         </div>
//                         {isOpen && (
//                             <div
//                                 style={{
//                                     position: 'absolute',
//                                     top: -130,
//                                     left: 0,
//                                     backgroundColor: 'white',
//                                     border: '1px solid #ccc',
//                                     borderRadius: '4px',
//                                     zIndex: 10,
//                                     maxHeight: '130px', // control visible height
//                                     overflowY: 'auto',  // enables vertical scroll
//                                     width: '100%',
//                                 }}
//                             >
//                                 {codes.map(code => (
//                                     <div
//                                         key={code}
//                                         onClick={() => handleSelect(code)}
//                                         style={{
//                                             padding: '12px',
//                                             cursor: 'pointer',
//                                             borderBottom: '1px solid #eee',
//                                             backgroundColor: "white"

//                                         }}
//                                     >
//                                         {code}
//                                     </div>
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                     <svg.SearchSvg />

//                     {/* Phone Number Input */}
//                     <input
//                         type="tel"
//                         placeholder="Enter phone number"
//                         value={phoneNumber}
//                         // onChange={e => setPhoneNumber(e.target.value)}
//                         onChange={e => setPhoneNumber(e.target.value.replace(/\D/, ''))}
//                         pattern="\d{10}"
//                         maxLength={10}
//                         style={{
//                             fontSize: "16px",
//                             width: "100%",
//                             padding: '12px',
//                             borderRadius: '4px',
//                             border: '1px solid #ccc',
//                             flex: 1,
//                         }}
//                     />
//                 </div>

//             </div>
//         );
//     };

//     const renderButtons = (): JSX.Element => (
//         <div
//             style={{
//                 position: 'absolute',
//                 bottom: 0,
//                 width: '100%',
//                 padding: '36px 16px 36px 16px',
//                 background: ' #ffffffa1',
//                 backdropFilter: 'blur(4px)',
//                 boxSizing: 'border-box',
//                 borderTopLeftRadius: 16,
//                 borderTopRightRadius: 16,
//             }}
//         >
//             <div
//                 className='button-container'
//                 style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
//             >
//                 {renderTitle()}
//                 {renderDescription()}
//                 {renderDescription1()}


//                 {buttons.map((btn, index) => (
//                     <div
//                         key={index}
//                         id="onbording3"
//                         className={index === 0 ? 'active-button' : 'inactive-button'}
//                         onClick={() => navigate(btn.path)}
//                     >
//                         <span>{btn.title}</span>
//                     </div>
//                     // <components.Button
//                     //     key={index}
//                     //     style={{
//                     //         backgroundColor: index === 0 ? '#7065F0' : '#fff',
//                     //         color: index === 0 ? '#fff' : '#7065F0',
//                     //         border: '1px solid #7065F0',
//                     //     }}
//                     //     title={btn.title}
//                     //     onClick={() => navigate(btn.path)}
//                     // />
//                 ))}

//                 {renderDescription2()}

//             </div>
//         </div>
//     );

//     return (
//         // <div style={{ position: 'relative', minHeight: '100vh' }}>
//         //     <div style={{ width: '100%', height: '100vh', overflow: 'hidden', position: 'relative' }}>
//         //         <img
//         //             src={require('../assets/nestfin/mainb1.jpg')}
//         //             alt='Onboarding Visual'
//         //             style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//         //         />
//         //         {renderButtons()}
//         //     </div>
//         // </div>

//         <div style={{ position: 'relative', height: '100dvh', overflow: 'hidden' }}>
//             <div style={{ width: '100%', height: '100%', overflow: 'hidden', position: 'relative' }}>
//                 <img
//                     src={require('../assets/nestfin/mainb1.jpg')}
//                     alt='Onboarding Visual'
//                     style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                 />
//                 {renderButtons()}
//             </div>
//         </div>

//     );
// };





